var togglePasswordVisibility = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {
		const elements = target.querySelectorAll('[data-toggle-password]');

		elements.forEach(function (element) {

			/* Password field naar textveld converteren op basis van data-toggle-password attribute */
			const showPassword = function() {
				const prevElement = this.previousElementSibling;
				if (prevElement) {
					prevElement.type = 'text';
				}
			};

			/* Textfield naar password field converteren op basis van data-toggle-password attribute  */
			const hidePassword = function() {
				const prevElement = this.previousElementSibling;
				if (prevElement) {
					prevElement.type = 'password';
				}
			};

			/* Event listeners for desktop (mousedown/mouseup) */
			element.addEventListener('mousedown', showPassword);
			element.addEventListener('mouseup', hidePassword);
			element.addEventListener('mouseleave', hidePassword);

			/* Event listeners for mobile (touchstart/touchend) */
			element.addEventListener('touchstart', showPassword);
			element.addEventListener('touchend', hidePassword);
		});
	}

};

export default togglePasswordVisibility;
